import {Injector} from "@angular/core";

export class ServiceFinder {
    public static injector: Injector;
}


// WEBPACK FOOTER //
// ./src/app/services/finder.service.ts